/** One grant of a role: an entity's own copy, or (entityId null) a ServEngine-level role. */
export type RoleGrant = { roleId: string; endsOn: string | null; entityId: string | null };

/**
 * Whether an entity's scope can be written yet: the scope routes refuse a box no held role puts
 * in play there, so it waits for the grant that reaches it. A ServEngine-level role is one grant
 * that reaches every entity; an entity role reaches only its own entity.
 *
 * `granted` is every grant that has landed so far, this attempt or an earlier one, so a retry that
 * sends no grants still writes the scope the first attempt left unsaved.
 */
export const grantReaches = (grants: RoleGrant[], granted: string[], tenantId: string): boolean =>
  grants.some(
    (grant) =>
      granted.includes(grant.roleId) && (grant.entityId === null || grant.entityId === tenantId),
  );
